export default {
  subscription: 'specialsauce',
  mailing_list: 32,
  info_url: '',
  title: {
    in_progress: 'GoodLife Brewing presents',
    success: '',
    subtext: "G. Love's Special Sauce IPA",
  },
  cancel_anytime: null,
  review: {
    agreement: null,
    title: 'Add me!',
    summary: [
      "By being on the list, you'll get exclusive access to Special Sauce on Tavour's app!",
    ],
    button_text: 'Add me to the list',
  },
};



// WEBPACK FOOTER //
// ./src/settings/specialsauce.js